{
  "name": "@streamplace/app",
  "main": "./src/entrypoint.tsx",
  "engines": {
    "node": "22.x"
  },
  "version": "0.11.29",
  "runtimeVersion": "0.12.0",
  "scripts": {
    "start": "npx expo start -c --port 38081",
    "start:fast": "npx expo start --port 38081",
    "dev:ios": "bash scripts/dev-ios.sh",
    "ui:shoot": "bash scripts/ui-shoot.sh",
    "android": "expo run:android --no-bundler",
    "ios": "expo run:ios --no-bundler",
    "web": "npx expo start --web --port 38081",
    "test": "jest --watchAll",
    "brand": "pnpm --filter @streamplace/brand generate",
    "build": "pnpm run build:web && pnpm run prebuild",
    "build:web": "pnpm run brand && node scripts/generate-build-info.js && pnpm run export && node exportClientExpoConfig.js > dist/expoConfig.json",
    "export": "expo export --dump-sourcemap || expo export --dump-sourcemap",
    "check": "pnpm --filter @streamplace/i18n compile && bash -c 'set -euo pipefail;export OUT=$(mktemp -d); npx tsc -p . --outDir $OUT; rm -rf $OUT'",
    "prebuild": "pnpm run brand && EXPO_NO_GIT_STATUS=1 expo prebuild --clean && sed -i.bak 's/org.gradle.jvmargs=-Xmx2048m -XX:MaxMetaspaceSize=512m/org.gradle.jvmargs=-Xmx4096m -XX:MaxMetaspaceSize=1024m/' android/gradle.properties && pnpm run find-node",
    "prepare": "which pod && pnpm run prepare-ios || echo 'not a mac, not installing pods' && mkdir -p ./public && cp -r ../i18n/public/locales ./public/",
    "prepare-ios": "cd ios && pod install && pnpm run find-node",
    "find-node": "node -p '`NODE_BINARY=${process.argv[0]}`' > ios/.xcode.env.local",
    "code-signing-dev": "mkdir -p code-signing-dev/keys code-signing-dev/certs && expo-updates codesigning:generate --key-output-directory code-signing-dev/keys --certificate-output-directory code-signing-dev/certs --certificate-validity-duration-years 10 --certificate-common-name 'Streamplace'",
    "i18n:compile": "node scripts/compile-translations.js",
    "i18n:copy": "mkdir -p public/locales && cp -r src/i18n/locales/data/* public/locales/",
    "i18n:build": "npm run i18n:compile && npm run i18n:copy",
    "i18n:watch": "nodemon --exec \"npm run i18n:build\" --watch src/i18n/locales/data/**/*.ftl",
    "i18n:extract": "node scripts/extract-i18n.js && node scripts/migrate-keys-to-ftl.js",
    "gen:emoji": "node scripts/gen-emoji-data.js"
  },
  "jest": {
    "preset": "jest-expo"
  },
  "dependencies": {
    "@atproto-labs/pipe": "^0.1.1",
    "@atproto/api": "^0.19.3",
    "@atproto/crypto": "^0.4.5",
    "@atproto/jwk-jose": "^0.1.11",
    "@atproto/jwk-webcrypto": "^0.2.0",
    "@atproto/oauth-client": "^0.6.0",
    "@atproto/oauth-client-browser": "^0.3.41",
    "@atproto/oauth-client-expo": "^0.0.10",
    "@babel/runtime": "^7.28.6",
    "@bacons/text-decoder": "^0.0.0",
    "@expo-google-fonts/inter": "0.4.2",
    "@fluent/bundle": "^0.19.1",
    "@fluent/langneg": "^0.7.0",
    "@fluent/react": "^0.15.2",
    "@formatjs/intl-displaynames": "^7.3.8",
    "@formatjs/intl-getcanonicallocales": "^3.2.9",
    "@formatjs/intl-locale": "^5.3.8",
    "@react-native-firebase/app": "^23.7.0",
    "@react-native-firebase/messaging": "^23.7.0",
    "@react-navigation/bottom-tabs": "8.0.0-alpha.16",
    "@react-navigation/drawer": "^8.0.0-alpha.16",
    "@react-navigation/native": "^8.0.0-alpha.14",
    "@react-navigation/native-stack": "^8.0.0-alpha.16",
    "@sentry/cli": "^3.3.3",
    "@sentry/react-native": "^7.11.0",
    "@streamplace/components": "workspace:*",
    "@streamplace/core": "workspace:*",
    "@tanstack/react-query": "^5.59.19",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "abortcontroller-polyfill": "^1.7.6",
    "babel-preset-expo": "~55.0.9",
    "buffer": "^6.0.3",
    "burnt": "^0.12.2",
    "chrono-node": "2.7.7",
    "color-contrast-checker": "^2.1.0",
    "event-target-shim": "^6.0.2",
    "expo": "~55.0.3",
    "expo-build-properties": "~55.0.9",
    "expo-crypto": "^55.0.9",
    "expo-dev-client": "~55.0.10",
    "expo-document-picker": "^55.0.13",
    "expo-file-system": "~55.0.10",
    "expo-font": "~55.0.4",
    "expo-image": "^55.0.6",
    "expo-keep-awake": "~55.0.4",
    "expo-linking": "~55.0.7",
    "expo-localization": "^55.0.8",
    "expo-notifications": "~55.0.10",
    "expo-screen-orientation": "^55.0.8",
    "expo-splash-screen": "~55.0.10",
    "expo-sqlite": "~55.0.10",
    "expo-system-ui": "~55.0.9",
    "expo-updates": "~55.0.12",
    "expo-video": "~55.0.10",
    "expo-web-browser": "^55.0.9",
    "frimousse": "^0.3.0",
    "hls.js": "^1.5.17",
    "i18next": "^25.4.2",
    "i18next-browser-languagedetector": "^8.2.0",
    "i18next-fluent": "^2.0.0",
    "i18next-http-backend": "^3.0.2",
    "i18next-resources-to-backend": "^1.2.1",
    "intl-pluralrules": "^2.0.1",
    "jose": "^5.9.6",
    "lucide-react-native": "^0.562.0",
    "metro-react-native-babel-transformer": "^0.77.0",
    "multiformats": "^13.3.1",
    "qrcode": "^1.5.4",
    "quietjs-bundle": "^0.1.3",
    "react": "19.2.0",
    "react-dom": "19.2.0",
    "react-i18next": "^15.7.3",
    "react-native": "0.83.2",
    "react-native-edge-to-edge": "^1.6.2",
    "react-native-gesture-handler": "~2.30.0",
    "react-native-localize": "^3.5.2",
    "react-native-markdown-display": "^7.0.2",
    "react-native-reanimated": "~4.2.1",
    "react-native-safe-area-context": "5.7.0",
    "react-native-screens": "4.24.0",
    "react-native-sortables": "^1.9.4",
    "react-native-svg": "15.15.3",
    "react-native-web": "^0.21.2",
    "react-native-webrtc": "git+https://github.com/streamplace/react-native-webrtc.git#74fa32266e3a2fee180f5e01bb8753af2a92d9d3",
    "react-native-webview": "13.16.0",
    "react-use-websocket": "^4.13.0",
    "reanimated-color-picker": "^4.0.0",
    "rtcaudiodevice": "git+https://github.com/streamplace/RTCAudioDevice.git#38bf55484ca14366e4322c565aa4ed025107734b",
    "sdp-transform": "^2.15.0",
    "stream-http": "^3.2.0",
    "streamplace": "workspace:*",
    "tus-js-client": "^4.3.1",
    "ua-parser-js": "^2.0.0-rc.1",
    "uuid": "^11.0.2",
    "viem": "^2.21.44",
    "zustand": "^5.0.5"
  },
  "devDependencies": {
    "@babel/core": "^7.26.0",
    "@babel/plugin-proposal-export-default-from": "^7.25.9",
    "@babel/plugin-syntax-export-default-from": "^7.25.9",
    "@babel/plugin-transform-flow-strip-types": "^7.25.9",
    "@babel/plugin-transform-private-methods": "^7.25.9",
    "@babel/plugin-transform-private-property-in-object": "^7.25.9",
    "@babel/plugin-transform-runtime": "^7.25.9",
    "@config-plugins/react-native-webrtc": "^10.0.0",
    "@expo/metro-runtime": "~55.0.6",
    "@types/babel__plugin-transform-runtime": "^7",
    "@types/qrcode": "^1",
    "@types/react": "~19.2.14",
    "@types/sdp-transform": "^2.15.0",
    "@types/uuid": "^10.0.0",
    "emojibase-data": "^17.0.0",
    "i18next-parser": "^9.0.1",
    "typescript": "~5.9.3"
  },
  "private": true
}
